import React, { ReactNode, createContext, useContext, useMemo, useState } from 'react';

import { useParams, useSearchParams } from 'react-router-dom';

export interface CsvRowError {
  row: string;
  columnName: string;
  message: string;
}

interface CustomFundLineupContextValue {
  returnTo: string;
  planName: string;
  solo401kPlanId: string;
  rowErrors: CsvRowError[];
  setRowErrors: React.Dispatch<React.SetStateAction<CsvRowError[]>>;
}

const CustomFundLineupContext = createContext<CustomFundLineupContextValue>({
  returnTo: '',
  planName: '',
  solo401kPlanId: '',
  rowErrors: [],
  setRowErrors: () => {},
});

interface CustomFundLineupProviderProps {
  children: ReactNode;
}

export const CustomFundLineupProvider: React.FC<CustomFundLineupProviderProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const { solo401kPlanId = '' } = useParams<{ solo401kPlanId: string }>();

  const [returnTo] = useState<string>(() => searchParams.get('returnTo') || '');
  const [planName] = useState<string>(() => searchParams.get('planName') || '');
  const [rowErrors, setRowErrors] = useState<CsvRowError[]>([]);

  const value: CustomFundLineupContextValue = useMemo(
    () => ({
      returnTo,
      planName,
      solo401kPlanId,
      rowErrors,
      setRowErrors,
    }),
    [returnTo, planName, solo401kPlanId, rowErrors]
  );

  return <CustomFundLineupContext.Provider value={value}>{children}</CustomFundLineupContext.Provider>;
};

export const useCustomFundLineup = (): CustomFundLineupContextValue => {
  return useContext(CustomFundLineupContext);
};
